module.exports = __webpack_public_path__ + "img/viblo-partner.af16a3b6.png";